import { useTranslation } from "@redotech/redo-i18n";
import type { IsGiftReturnState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const IsGiftReturnDetails = memo(function IsGiftReturnDetails({
  disabled,
}: ConditionTypeDetailsProps<IsGiftReturnState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Condition")}
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
        {t("Applies when the return is a gift return.")}
      </Text>
    </Flex>
  );
});
